var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('p',[_vm._v(" от "),_c('span',[_vm._v(_vm._s(_vm._f("moneyFormat")(_vm.rangeMin)))])]),_c('p',[_vm._v(" до "),_c('span',[_vm._v(_vm._s(_vm._f("moneyFormat")(_vm.rangeMax)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }